import { Box, Divider, Grid, Typography } from "@material-ui/core";
import { Button } from "@roc/ui";
import { observer } from "mobx-react";
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router";
import { useAppRoutes } from "../../../hooks";

const useStyles = makeStyles(theme =>
  createStyles({
    gridContainer: {
      padding: theme.spacing(4),
      width: '100%',
      maxWidth: 500,
      margin: 'auto',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0),
      },
    },
    registerLabels: {
      fontSize: '14px',
      fontWeight: 'bold',
      marginRight: '10px'
    },
    registerLabelsSubText: {
      fontSize: '14px',
      marginBottom: '8px',
      marginRight: '5px'
    },
    divider: {
      marginTop: '10px',
      marginBottom: '10px'
    }
  })
);


export const NewButtonsForBorrowersAccount = observer(() => {
  const classes = useStyles();
  const { push } = useHistory();
  const { publicRoutes } = useAppRoutes();


  const handleApplyForLoanPublic = () => {
    push(publicRoutes.applyForALoan.url)
  }

  return (
    <>
      <Grid item xs={12}>
        <Divider className={classes.divider}></Divider>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Typography className={classes.registerLabels} color="textSecondary">Just want to apply?</Typography>
        <Typography className={classes.registerLabelsSubText} color="textSecondary">Submit your loan request without signing up.</Typography>
        <Button
          fullWidth
          variant="contained"
          type="submit"
          onClick={handleApplyForLoanPublic}
          testId="submit"
        >
            Apply for a Loan
        </Button>
      </Grid>
    </>
  )
})